/* eslint-disable */
// import router from "@/router";
export const serialize = function (obj) {
	var str = [];
	for (var p in obj)
		if (obj.hasOwnProperty(p)) {
			if (!obj[p]) continue;
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		}
	return `?${str.join("&")}`;
};

export function isTissError(source) {
  if (!source || typeof source !== 'object') return false;
  if (source.tissError === true) return true;
  if (source.data?.tissError === true) return true;
  if (source.response?.data?.tissError === true) return true;
  if (source.message?.tissError === true) return true;
  if (source.message?.data?.tissError === true) return true;
  return false;
}

export const WeekDayOptions = function (option) {
	if (option === "day") {
		// router.push({ name: "schedule-day" });
		window.location.href = "/app/schedule-day";
	} else {
		// router.push({ name: "schedule-week" });
		window.location.href = "/app/schedule-week";
	}
};
